import { attachGridHover, attachNearestHover, attachValueHover } from '../core/interaction';
import { registerDashboard } from '../../registryCore';
import { createWidgetGroup, num, setState, str } from '../../helpers';
import { getActiveDashboard } from '../../theme';
import { sampleZGrid, surfaceMeshPath, wireframePaths } from '../core/projection3d';
import { layoutWordCloud } from '../core/wordLayout';
registerDashboard('surfaceChart3d', function (props, app) {
    var _a, _b, _c;
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 200);
    var zGrid = (_a = props.zGrid) !== null && _a !== void 0 ? _a : sampleZGrid(8);
    var group = createWidgetGroup(app, 'surfaceChart3d', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var paths = surfaceMeshPath(zGrid, width / 2, height / 2 + 20, 6);
    paths.forEach(function (d, i) {
        group.add(app.path({ d: d, fill: getActiveDashboard().series[i % getActiveDashboard().series.length], opacity: 0.6, stroke: getActiveDashboard().chartGrid, strokeWidth: 0.5, listening: false }));
    });
    attachGridHover(app, group, props, width, height, zGrid.length, (_c = (_b = zGrid[0]) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 1, function (r, c) { var _a, _b; return String((_b = (_a = zGrid[r]) === null || _a === void 0 ? void 0 : _a[c]) !== null && _b !== void 0 ? _b : ''); });
    setState(group, { width: width, height: height, zGrid: zGrid });
    return group;
});
registerDashboard('wireframeChart3d', function (props, app) {
    var _a, _b, _c;
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 200);
    var zGrid = (_a = props.zGrid) !== null && _a !== void 0 ? _a : sampleZGrid(8);
    var group = createWidgetGroup(app, 'wireframeChart3d', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    wireframePaths(zGrid, width / 2, height / 2 + 20, 6).forEach(function (d) {
        group.add(app.path({ d: d, fill: null, stroke: getActiveDashboard().chartLine, strokeWidth: 1, listening: false }));
    });
    attachGridHover(app, group, props, width, height, zGrid.length, (_c = (_b = zGrid[0]) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 1, function (r, c) { var _a, _b; return String((_b = (_a = zGrid[r]) === null || _a === void 0 ? void 0 : _a[c]) !== null && _b !== void 0 ? _b : ''); });
    setState(group, { width: width, height: height, zGrid: zGrid });
    return group;
});
registerDashboard('meshChart3d', function (props, app) {
    var _a, _b, _c;
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 200);
    var zGrid = (_a = props.zGrid) !== null && _a !== void 0 ? _a : sampleZGrid(6);
    var group = createWidgetGroup(app, 'meshChart3d', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    surfaceMeshPath(zGrid, width / 2, height / 2 + 20, 8).forEach(function (d) {
        group.add(app.path({ d: d, fill: getActiveDashboard().chartArea, stroke: getActiveDashboard().primary, strokeWidth: 1, listening: false }));
    });
    attachGridHover(app, group, props, width, height, zGrid.length, (_c = (_b = zGrid[0]) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 1, function (r, c) { var _a, _b; return String((_b = (_a = zGrid[r]) === null || _a === void 0 ? void 0 : _a[c]) !== null && _b !== void 0 ? _b : ''); });
    setState(group, { width: width, height: height, zGrid: zGrid });
    return group;
});
registerDashboard('vectorFieldChart', function (props, app) {
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 200);
    var group = createWidgetGroup(app, 'vectorFieldChart', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var cols = 8;
    var rows = 6;
    for (var i = 0; i < rows; i++) {
        for (var j = 0; j < cols; j++) {
            var x = 20 + (j / (cols - 1)) * (width - 40);
            var y = 20 + (i / (rows - 1)) * (height - 40);
            var angle = Math.sin(j * 0.5) * Math.cos(i * 0.5);
            var len = 12;
            group.add(app.line({
                x: x,
                y: y,
                x2: len * Math.cos(angle),
                y2: len * Math.sin(angle),
                stroke: getActiveDashboard().chartLine,
                strokeWidth: 1.5,
                lineCap: 'round',
                listening: false,
            }));
        }
    }
    attachGridHover(app, group, props, width, height, rows, cols, function () { return 'flow'; });
    setState(group, { width: width, height: height });
    return group;
});
registerDashboard('pictogramChart', function (props, app) {
    var width = num(props, 'width', 200);
    var height = num(props, 'height', 120);
    var value = num(props, 'value', 12);
    var icon = str(props, 'icon', '●');
    var group = createWidgetGroup(app, 'pictogramChart', props);
    var cols = 6;
    for (var i = 0; i < value; i++) {
        var col = i % cols;
        var row = Math.floor(i / cols);
        group.add(app.text({
            text: icon,
            x: col * 28 + 4,
            y: row * 28 + 4,
            fontSize: 18,
            fill: getActiveDashboard().primary,
            listening: false,
        }));
    }
    attachValueHover(app, group, props, width, height, "count: ".concat(value));
    setState(group, { width: width, height: height, value: value });
    return group;
});
registerDashboard('wordCloudChart', function (props, app) {
    var _a;
    var width = num(props, 'width', 320);
    var height = num(props, 'height', 200);
    var words = (_a = props.words) !== null && _a !== void 0 ? _a : [
        { text: 'data', value: 90 },
        { text: 'chart', value: 70 },
        { text: 'visual', value: 55 },
        { text: 'lightdraw', value: 80 },
        { text: 'canvas', value: 45 },
        { text: 'dashboard', value: 60 },
    ];
    var group = createWidgetGroup(app, 'wordCloudChart', props);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var placed = layoutWordCloud(words, width, height);
    placed.forEach(function (w, i) {
        group.add(app.text({
            text: w.text,
            x: w.x,
            y: w.y,
            fontSize: w.fontSize,
            fontWeight: i < 3 ? '700' : '400',
            fill: getActiveDashboard().series[i % getActiveDashboard().series.length],
            listening: false,
        }));
    });
    attachNearestHover(app, group, props, { x: 0, y: 0, width: width, height: height }, placed.map(function (w) {
        var _a;
        return ({
            x: w.x + w.fontSize / 2,
            y: w.y + w.fontSize / 2,
            label: "".concat(w.text, " (").concat((_a = w.value) !== null && _a !== void 0 ? _a : '', ")"),
        });
    }));
    setState(group, { width: width, height: height, words: words });
    return group;
});
